<div class="modal-header">
	<h5 class="modal-title fenster-titel">
		<span>{{ titel }}</span>
		@if (hbf) {
			<code>{{ hbf }}</code>
		}
	</h5>
	<button type="button" class="btn-close" aria-label="Schließen" (click)="aktiv.dismiss()"></button>
</div>
<div class="modal-body">
	<div class="fenster-leiste">
		@if (steckbriefe.length > 1) {
			<div class="btn-group" role="group" aria-label="Katalogseiten">
				@for (s of steckbriefe; track s.id; let i = $index) {
					<button type="button" class="btn btn-outline-secondary btn-sm" [class.active]="i === index" (click)="index = i">{{ seitenName(s, i) }}</button>
				}
			</div>
		}
		@if (hatOriginal(aktuell)) {
			<button type="button" class="btn btn-outline-secondary btn-sm knopf-mit-symbol" [class.active]="original"
				(click)="original = !original" title="Originalseite des Katalogs dazublenden">
				<i class="bi bi-file-image"></i>
				<span>{{ original ? 'Original aus' : 'Original' }}</span>
			</button>
		}
	</div>
	@if (aktuell; as s) {
		<div class="fenster-inhalt" [class.mit-original]="original && hatOriginal(s)">
			@if (original && hatOriginal(s)) {
				<div class="fenster-original">
					<app-sea-original [pdf]="s.pdf" [page]="s.page"></app-sea-original>
				</div>
			}
			<div class="fenster-steckbrief">
				<app-bodensteckbrief-preview [entry]="s" [embedded]="true"></app-bodensteckbrief-preview>
			</div>
		</div>
	}
</div>
<div class="modal-footer">
	<button type="button" class="btn btn-outline-secondary" (click)="imKatalogLeser()">Im Katalog-Leser öffnen</button>
	<button type="button" class="btn btn-primary" (click)="aktiv.dismiss()">Zurück zur Aufnahme</button>
</div>
